'use client'
import React, { useState, useMemo } from 'react'
//material ui imports
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AddIcon from '@mui/icons-material/Add';
import MyStuff from './my_stuff';
import SubAccordion from './SubAccordion';
import { v4 as uuidv4 } from 'uuid'
import { gtmClickTracking } from '@/utils';
export interface GetTrayComponentsForThreeDBuilderProps {
    isInteriorDesigner:boolean;
    isShowcaseFlow: boolean;
    isDesignShowcase: boolean;
    productId: any;
    productType: any;
    includeRecommendations: boolean;
    setIsInfoSectionVisible: any;
    isInfoSectionVisible: boolean;
    handleMenuCloseDesignDetail: (isCloseMenu: boolean) => void;
    handleSelectedDesignDetailId: (itemId: string) => void;
    handleMoreItemsClosed: (isCloseMenu: boolean) => void;
    handleActiveAccordion: (activeAccordion: any) => void;
    handleItems: (items: any) => void;
    handleCloseProductDetails: (isCloseMenu: boolean) => void;
    handleSelectedProductDetailId: (itemId: string) => void;
}
//accordion constants
export const accordionTitleConstants = {
    myStuff: 'My Stuff',
    designs: 'Designs',
    products: 'Products'
}
export const subAccordionConstants = {
    design: "Design",
    products: 'All Product(s)',
    scanned: 'Scanned',
    favorited: 'Favorited',
    recentlyViewed: 'Recently Viewed',
    designs: "All Design(s)",
    similarProducts: 'Similar Products',
    relatedProducts: 'Related Products'
}
const GetTrayComponentsForThreeDBuilder: React.FC<GetTrayComponentsForThreeDBuilderProps> = (props) => {
    //props
    const {isInteriorDesigner, isShowcaseFlow, isDesignShowcase, productId, productType, includeRecommendations, setIsInfoSectionVisible, isInfoSectionVisible, handleMenuCloseDesignDetail, handleSelectedDesignDetailId, handleMoreItemsClosed, handleActiveAccordion, handleItems, handleCloseProductDetails, handleSelectedProductDetailId } = props
    //state
    const [expanded, setExpanded] = useState<string | false>('panel1');
    const handleAccordianChange =
        (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
            setExpanded(isExpanded ? panel : false);
            if (panel === 'panel1') {
                gtmClickTracking({ event:'my_stuff'})
            }
            if (panel === 'panel2') {
                gtmClickTracking({ event: `${accordionTitleConstants.designs}` })
            }
            if (panel === 'panel3') {
                gtmClickTracking({ event: `${accordionTitleConstants.products}` })
            }
        };
    //accordions data
    const designsAccordionData = useMemo(() => (
        {
            title: accordionTitleConstants.designs,
            accordions: [
                { id: uuidv4(), accordionTitle: subAccordionConstants.favorited, panel: 'panel1', apiUrl: 'https://nestingale.com/v1/api/customer-favorites?type=design&has3DSupport=true' },
                { id: uuidv4(), accordionTitle: subAccordionConstants.recentlyViewed, panel: 'panel2', apiUrl: 'https://nestingale.com/v1/api/customer/recently-viewed?type=design&has3DSupport=true' },
                { id: uuidv4(), accordionTitle: subAccordionConstants.designs, panel: 'panel3', apiUrl: 'https://nestingale.com/v2/api/designs?has3DSupport=true' },
            ]
        }
    ), [])
    const productsAccordionData = useMemo(() => {
        const baseAccordions = [
            { id: uuidv4(), accordionTitle: subAccordionConstants.favorited, panel: 'panel1', apiUrl: 'https://nestingale.com/v1/api/customer-favorites?type=product' },
            { id: uuidv4(), accordionTitle: subAccordionConstants.recentlyViewed, panel: 'panel2', apiUrl: 'https://nestingale.com/v1/api/customer/recently-viewed?type=product' },
            { id: uuidv4(), accordionTitle: subAccordionConstants.products, panel: 'panel3', apiUrl: 'https://nestingale.com/v1/api/products?has3DModel=true' },
        ]
        if (isShowcaseFlow && (!isDesignShowcase) && (!isInteriorDesigner)) {
            baseAccordions.splice(2, 0, { id: uuidv4(), accordionTitle: subAccordionConstants.similarProducts, panel: 'panel4', apiUrl: `https://nestingale.com/v1/api/productDetails?${productId && `productId=${productId}&`}includeRecommendations=true&filterBy3D=true` },
                { id: uuidv4(), accordionTitle: subAccordionConstants.relatedProducts, panel: 'panel5', apiUrl: `https://nestingale.com/v1/api/productDetails?${productId && `productId=${productId}&`}includeRecommendations=true&filterBy3D=true` },
            )
        }
        return {
            title: accordionTitleConstants.products,
            accordions: baseAccordions
        }
    }, [isShowcaseFlow, productId, isDesignShowcase])
    return (
        <>
            <Box component="div" className="custom-accordion">
                <Box component="div" sx={{ display: 'flex', alignItems: 'center', columnGap: '5px', width: '100%', marginBottom: '10px' }}>
                    <AddCircleOutlineIcon sx={{ fontSize: '25px', color: '#52575C' }} /><Box component="span" sx={{ margin: '0 auto', color: '#000' }}>Browse</Box><div onClick={() => { setIsInfoSectionVisible(!isInfoSectionVisible) }} ><ErrorOutlineIcon sx={{ fontSize: '25px', cursor: 'pointer', marginLeft: 'auto', color: '#52575C' }} /></div>
                </Box>
                <Box component="div">
                    <Accordion expanded={expanded === 'panel1'} onChange={handleAccordianChange('panel1')}>
                        <AccordionSummary
                            expandIcon={expanded === 'panel1' ? <RemoveIcon sx={{ fontSize: '18px', color: '#fff' }} /> : <AddIcon sx={{ fontSize: '18px', color: '#fff' }} />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                        >
                            <Typography>
                                My Stuff
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ maxWidth: '200px' }}>
                            <MyStuff isShowcaseFlow={isShowcaseFlow} isDesignShowcase={isDesignShowcase} productId={productId} includeRecommendations={includeRecommendations} productType={productType} handleCloseProductDetails={handleCloseProductDetails} handleSelectedProductDetailId={handleSelectedProductDetailId} />
                        </AccordionDetails>
                    </Accordion>
                    {!(isShowcaseFlow && !isDesignShowcase) && <Accordion expanded={expanded === 'panel2'} onChange={handleAccordianChange('panel2')}>
                        <AccordionSummary
                            expandIcon={expanded === 'panel2' ? <RemoveIcon sx={{ fontSize: '18px', color: '#fff' }} /> : <AddIcon sx={{ fontSize: '18px', color: '#fff' }} />}
                            aria-controls="panel2bh-content"
                            id="panel2bh-header"
                        >
                            <Typography>
                                Designs
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ maxWidth: '200px' }}>
                            <SubAccordion
                                accordionData={designsAccordionData}
                                isShowcaseFlow={isShowcaseFlow}
                                handleMenuCloseDesignDetail={handleMenuCloseDesignDetail}
                                handleSelectedDesignDetailId={handleSelectedDesignDetailId}
                                handleMoreItemsClosed={handleMoreItemsClosed}
                                handleActiveAccordion={handleActiveAccordion}
                                handleItems={handleItems}
                                handleCloseProductDetails={handleCloseProductDetails}
                                handleSelectedProductDetailId={handleSelectedProductDetailId}
                            />
                        </AccordionDetails>
                    </Accordion>}
                    <Accordion expanded={expanded === 'panel3'} onChange={handleAccordianChange('panel3')}>
                        <AccordionSummary
                            expandIcon={expanded === 'panel3' ? <RemoveIcon sx={{ fontSize: '18px', color: '#fff' }} /> : <AddIcon sx={{ fontSize: '18px', color: '#fff' }} />}
                            aria-controls="panel3bh-content"
                            id="panel3bh-header"
                        >
                            <Typography>
                                Products
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ maxWidth: '200px' }}>
                            <SubAccordion
                                accordionData={productsAccordionData}
                                isShowcaseFlow={isShowcaseFlow}
                                // handleMenuCloseDesignDetail and handleSelectedDesignDetailId not needed for products accordion but i'm sending it to silent the tsx warning
                                handleMenuCloseDesignDetail={handleMenuCloseDesignDetail}
                                handleSelectedDesignDetailId={handleSelectedDesignDetailId}
                                handleMoreItemsClosed={handleMoreItemsClosed}
                                handleActiveAccordion={handleActiveAccordion}
                                handleItems={handleItems}
                                handleCloseProductDetails={handleCloseProductDetails}
                                handleSelectedProductDetailId={handleSelectedProductDetailId}
                            />
                        </AccordionDetails>
                    </Accordion>
                </Box>
            </Box>
        </>
    );
};

GetTrayComponentsForThreeDBuilder.displayName = 'GetTrayComponentsForThreeDBuilder';
export default GetTrayComponentsForThreeDBuilder